export const isTransitionComplete = (fn: () => void) => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      fn();
    });
  });
};

export default {};
